"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VIEWPORT_SIZES = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _reactMedia = _interopRequireDefault(require("react-media"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _helpers = require("../helpers");

var _context = require("../context");

var _utils = require("../utils");

var _core = require("@emotion/core");

var VIEWPORT_SIZES = {
  S: 's',
  M: 'm',
  L: 'l',
  XL: 'xl'
};
exports.VIEWPORT_SIZES = VIEWPORT_SIZES;

function breakpointExists(breakpoint) {
  return breakpoint !== undefined;
}

var buildMediaQuery = function buildMediaQuery(_ref) {
  var sizes = _ref.sizes,
      context = _ref.context;
  return sizes.map(function (size) {
    switch ((0, _typeof2.default)(size)) {
      case 'object':
        return size;

      case 'string':
        {
          var breakpoint = context.selectors.breakpoint(size);

          if (!breakpoint) {
            console.error("The given breakpoint \"".concat(size, "\" does not exist in the theme"));
            return undefined;
          }

          return breakpoint;
        }

      default:
        console.error("The breakpoint should be an object or string, ".concat((0, _typeof2.default)(size), " provided"));
        return undefined;
    }
  }).filter(breakpointExists).map(function (_ref2) {
    var min = _ref2.min,
        max = _ref2.max;
    var query = 'screen';
    if (min) query += " and (min-width: ".concat(min, "px)");
    if (max) query += " and (max-width: ".concat(max, "px)");
    return query;
  }).join(', ');
};

var StencilMedia = function StencilMedia(_ref3) {
  var sizes = _ref3.sizes,
      context = _ref3.context,
      defaultMatches = _ref3.defaultMatches,
      children = _ref3.children;

  // If this is being rendered in a window context, use that
  // window as the target window. If there's no window context
  // in the component tree, then `contextWindow` will be undefined,
  // and `Media` will use the main browser window instead.
  var _useContext = (0, _react.useContext)(_helpers.WindowContext),
      contextWindow = _useContext.window;

  return (0, _core.jsx)(_reactMedia.default, {
    query: buildMediaQuery({
      sizes: sizes,
      context: context
    }),
    defaultMatches: defaultMatches,
    targetWindow: contextWindow
  }, function (matches) {
    return children((0, _objectSpread2.default)({}, context, {
      matches: matches
    }));
  });
};

StencilMedia.displayName = 'StencilMedia';

var StencilResponsiveConsumerWithoutDocs = function StencilResponsiveConsumerWithoutDocs(_ref4) {
  var children = _ref4.children,
      sizes = _ref4.sizes,
      stencilContext = _ref4.stencilContext,
      _ref4$defaultMatches = _ref4.defaultMatches,
      defaultMatches = _ref4$defaultMatches === void 0 ? true : _ref4$defaultMatches;
  (0, _utils.showDeprecationWarning)({
    deprecatedName: 'StencilResponsiveConsumer',
    replacementName: 'the `useBreakpoints` hook',
    docsLink: 'https://stencil.a2z.com/for-developers/responsiveness'
  });
  return stencilContext ? (0, _core.jsx)(StencilMedia, {
    sizes: sizes,
    context: stencilContext,
    defaultMatches: defaultMatches
  }, children) : (0, _core.jsx)(_context.StencilConsumer, null, function (context) {
    return (0, _core.jsx)(StencilMedia, {
      sizes: sizes,
      context: context,
      defaultMatches: defaultMatches
    }, children);
  });
};

var StencilResponsiveConsumer = (0, _stencilReactDesc.describe)(StencilResponsiveConsumerWithoutDocs).description('Stencil consumer which matches the given breakpoints.');
StencilResponsiveConsumer.displayName = 'StencilResponsiveConsumer';
StencilResponsiveConsumer.propTypes = {
  sizes: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string.description('Screen size name, to be read from the theme.'), _stencilReactDesc.PropTypes.shape({
    min: _stencilReactDesc.PropTypes.number,
    max: _stencilReactDesc.PropTypes.number
  }).description('Object with minWidth and maxWidth.')])).description('Screen sizes to match').isRequired,
  stencilContext: _stencilReactDesc.PropTypes.object.description("Value from Stencil's context, if passed the component won't be wrapped in a StencilConsumer."),
  children: _stencilReactDesc.PropTypes.func.description('Function as child receiving "matches", boolean prop representing whether the browser size matches the provided sizes.').format('({matches, ...stencilContext}) => node').isRequired,
  defaultMatches: _stencilReactDesc.PropTypes.bool.description('Whether the prop should match when server-side rendered.')
};
StencilResponsiveConsumer.displayName = 'StencilResponsiveConsumer';
var _default = StencilResponsiveConsumer;
exports.default = _default;